export enum PaymentType {
    Subscription = 'subscription',
    ManualPayment = 'manual',
}
